const fetch = require('node-fetch'); 

const storefrontAccessToken = process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN;
const domain = process.env.GATSBY_SHOP_NAME;

async function shopifyFetch({ query, variables = {} }) {
  const endpoint = `https://${domain}.myshopify.com/api/2025-01/graphql.json`;

  try {
    const result = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    // First get the JSON data
    const data = await result.json();
    
    // Then log the response details you want
    console.log('API Response Status:', result.status);
    console.log('API Response Data:', data);

    return {
      status: result.status,
      body: data,
    };
  } catch (error) {
    console.error('Error:', error);
    return {
      status: 500,
      error: 'Error receiving data',
    };
  }
}

async function getAllProducts() {
  const response = await shopifyFetch({
    query: `
      query GetProducts {
        products(first: 100) {
          edges {
            node {
              id
              handle
              title
              description
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              featuredImage {
                url
                altText
              }
              images(first: 20) {
                edges {
                  node {
                    url
                    altText
                  }
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    id
                    availableForSale
                    price {
                      amount
                      currencyCode
                    }
                    compareAtPrice {
                      amount
                      currencyCode
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
              availableForSale
              vendor
              productType
              metafield(namespace: "custom", key: "custom_sort_order") {
                value
              }
            }
          }
        }
      }
    `,
  });

  if (response.body && response.body.data && response.body.data.products) {
    // Extract the nodes from the edges array
    const products = response.body.data.products.edges.map(edge => edge.node);
    
    // Sort products based on custom_sort_order metafield
    return products.sort((a, b) => {
      const aSortOrder = a.metafield?.value ? parseInt(a.metafield.value) : Infinity;
      const bSortOrder = b.metafield?.value ? parseInt(b.metafield.value) : Infinity;
      
      return aSortOrder - bSortOrder;
    });
  }

  return [];
}


async function getAllCollections() {
  return shopifyFetch({
    query: `
      query GetCollections {
        collections(first: 100) {
          edges {
            node {
              id
              handle
              title
              description
              products(first: 100) {
                edges {
                  node {
                    id
                    handle
                    title
                    description
                    priceRange {
                      minVariantPrice {
                        amount
                        currencyCode
                      }
                      maxVariantPrice {
                        amount
                        currencyCode
                      }
                    }
                    featuredImage {
                      url
                      altText
                    }
                    variants(first: 100) {
                      edges {
                        node {
                          id
                          availableForSale
                          price {
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  });
} 

// Use CommonJS exports
module.exports = {
    shopifyFetch,
    getAllProducts, 
    getAllCollections
  };